export default __webpack_public_path__ + "static/media/3.196de72a.jpg";